import { createSlideIcon, type IconProps } from '../SlideTypeIcon';
const DEFAULT_COLOR = 'var(--palette-purple-700)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <circle cx="12" cy="12" r="2" fill={textColor} />
    <path d="M6 5V19L18 12L6 5Z" fill={textColor} />
  </>
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <circle cx="15.9999" cy="15.9999" r="2.90909" fill={textColor} />
    <path
      d="M9.91992 8.31982V23.5198L23.6799 15.9198L9.91992 8.31982Z"
      fill={textColor}
    />
  </>
);

export const VideoIcon = createSlideIcon(Icon24x24, Icon32x32);
